module.exports = __webpack_public_path__ + "static/img/a0dcc6828e6dc374ab7c048eda9bcef.5652524.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/imgs/newHome/a0dcc6828e6dc374ab7c048eda9bcef.png
// module id = TIRu
// module chunks = 1